export const UNIT_OF_MEASUREMENT = {
  GRAMS: 'g',
  MILLIGRAMS: 'mg',
  LITERS: 'L',
  MILLILITERS: 'ml',
  EACH: 'ea',
};



// WEBPACK FOOTER //
// ./src/const/unit_of_measurement.js